import React, { FC, useRef, useEffect } from 'react'
import { useField } from '@shared/lib/fields/hooks/useField/useField'
import { useFieldHint } from '@shared/lib/fields/hooks/useFieldHint/useFieldHint'
import { getDefaultField } from '@shared/lib/fields/getDefaultField'
import { Text } from '@shared/ui/Typography/Text'
import { InputHint } from '@shared/ui/Form/Single/InputHint'
import Button from '@shared/ui/Actions/Button/Button'
import Modal from '@shared/ui/Overlays/Modal/Modal'
import s from './CreateMessageModal.module.sass'

const MAX_CHARACTERS = 1000

interface CreateMessageModalProps {
  isVisible: boolean
  onClose: () => void
  onPublish: (message: string) => void
}

const CreateMessageModal: FC<CreateMessageModalProps> = ({ isVisible, onClose, onPublish }) => {
  const [message, setMessage, validMessage] = useField(
    getDefaultField('textarea', {
      name: 'message',
      value: '',
      required: true,
      validations: {
        'min-symbols-10': 'Сообщение должно содержать более 10 символов',
        'max-symbols-1000': 'Сообщение должно содержать не более 1000 символов',
      },
    }),
  )
  const [hint] = useFieldHint(message)

  const handlePublish = () => {
    const isValidMessage = validMessage().error === ''

    if (isValidMessage) {
      const normalized = message.value
        .replace(/ \r?\n/g, ' ')
        .replace(/\r?\n /g, ' ')
        .replace(/\r?\n/g, ' ')
        .trim()
      onPublish(normalized)
      setMessage({ ...message, value: '' })
      onClose()
    }
  }

  const textarea = useRef<HTMLTextAreaElement>(null)
  const wrapper = useRef<HTMLDivElement>(null)

  const handleResize = () => {
    if (textarea.current && wrapper.current) {
      // @ts-ignore
      textarea.current.style.height = '0'
      // @ts-ignore
      textarea.current.style.height = textarea.current.scrollHeight + 'px'

      setTimeout(() => {
        if (textarea.current && wrapper.current) {
          // @ts-ignore
          wrapper.current.style.height = textarea.current.scrollHeight + 66 + 'px'
        }
      }, 0)
    }
  }

  useEffect(() => {
    handleResize()
  }, [handleResize])

  if (!isVisible) return null

  return (
    <Modal size='S' title='Информация для гостей' titleSizes='h2' handleClose={onClose} buttonClose={true}>
      <div className={s.container}>
        <div className={s['textarea-container']} ref={wrapper}>
          <textarea
            className={s.textarea}
            ref={textarea}
            value={message.value}
            onChange={(e) => setMessage({ ...message, value: e.target.value })}
            placeholder={message.settings.placeholder}
            maxLength={MAX_CHARACTERS}
          />

          <Text sizes='S' className={s['count-text']}>
            {message.value.length} / {MAX_CHARACTERS}
          </Text>

          <InputHint text={hint.text} status={hint.status} sizes='S' className={s['error-text']} />
        </div>

        <Button sizes='XL' mode='black' onClick={handlePublish}>
          Опубликовать
        </Button>
      </div>
    </Modal>
  )
}

export default CreateMessageModal
